const BUTTON_SELECTOR = "#box_now_delivery_button";
const DETAILS_SELECTOR = "#box_now_selected_locker_details";
const SELECT_LABEL = "Select BOX NOW Locker";
const CHANGE_LABEL = "Change BOX NOW Locker";

function updateBoxNowCheckout() {
	const button = document.querySelector(BUTTON_SELECTOR);
	const details = document.querySelector(DETAILS_SELECTOR);

	if (!button) {
		return;
	}

	const hasSelectedLocker = Boolean(
		details &&
		details.querySelector(".locker-detail") &&
		window.getComputedStyle(details).display !== "none"
	);
	const label = hasSelectedLocker ? CHANGE_LABEL : SELECT_LABEL;

	if (button.textContent.trim() !== label) {
		button.textContent = label;
	}

	if (hasSelectedLocker) {
		details.setAttribute("role", "status");
		details.setAttribute("aria-live", "polite");
		button.setAttribute("aria-describedby", details.id);
	} else {
		button.removeAttribute("aria-describedby");
	}
}

function initializeBoxNowCheckout() {
	if (!document.body.classList.contains("woocommerce-checkout")) {
		return;
	}

	updateBoxNowCheckout();

	const checkoutRoot = document.querySelector("form.checkout") || document.body;
	const observer = new MutationObserver(updateBoxNowCheckout);

	observer.observe(checkoutRoot, {
		attributes: true,
		attributeFilter: ["style"],
		childList: true,
		subtree: true,
	});
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initializeBoxNowCheckout, { once: true });
} else {
	initializeBoxNowCheckout();
}
